export class Doc {
    public id                   :   string;
    public createdAt            ?:   Date;
    public updatedAt            ?:   Date;

    constructor(data: any = {}) {
        this.id                 =   data.id || '';
        this.createdAt          =   data.createdAt || new Date();
        this.updatedAt          =   new Date();
    }

    public toJson() {
        return {
            ...this
        };
    }
}

export class DocRef {
    public id                   :   string;
    
    constructor(data: any = {}) {
        this.id                 =   data.id || '';
    }

    public toJson() {
        return {
            ...this
        };
    }
}

export enum GSTTreatment {
    Registered                  =   'Registered Business',
    Unregistered                =   'Unregistered Business',
    None                        =   'None'
}

export enum PlaceOfSupply {
    TN                          =   'TN',
    KL                          =   'KL',
    KN                          =   'KN'
}

export enum Tax {
    GST0                        =   0,
    GST5                        =   5,
    GST18                       =   18
}

export enum Type {
    Goods                       =   'Goods',
    Service                     =   'Service'    
}

export enum Unit {
    KG                          =   'KG',
    BAG                         =   'BAG'    
}